import * as React from 'react';

import { SVGProps } from '../../types';

export const IconImportQuestionsSvg = ({
  title,
  titleId,
  ...props
}: SVGProps) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    focusable="false"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}

    <path
      d="M7.5 5C7.5 3.89543 8.39543 3 9.5 3H30C31.1046 3 32 3.89543 32 5V32C32 33.6569 30.6569 35 29 35H9.5C8.39543 35 7.5 34.1046 7.5 33V5Z"
      fill="#E4FBFF"
    />
    <rect
      x={5.75}
      y={1}
      width={24.5}
      height={32}
      rx={2}
      stroke="#0099C7"
      strokeWidth={1.5}
    />
    <rect
      x={9.75}
      y={6}
      width={16.5}
      height={12}
      rx={1}
      stroke="#0099C7"
      strokeWidth={1.5}
    />
    <path
      d="M11 9.75024L25.5 9.75024"
      stroke="#0099C7"
      strokeWidth={1.5}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M15.25 17.4951L15.25 6.49512"
      stroke="#0099C7"
      strokeWidth={1.5}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M20.75 17.4951L20.75 6.49512"
      stroke="#0099C7"
      strokeWidth={1.5}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M11.7742 29.09C10.8382 29.09 9.94721 28.802 9.20921 28.163L10.0732 26.984C10.5862 27.407 11.1712 27.695 11.7832 27.695C12.2152 27.695 12.4402 27.506 12.4402 27.236V27.227C12.4402 26.975 12.2512 26.822 11.5132 26.561C10.3252 26.156 9.48821 25.724 9.48821 24.581V24.554C9.48821 23.411 10.3612 22.61 11.7382 22.61C12.5842 22.61 13.3312 22.844 13.9882 23.375L13.1692 24.581C12.7372 24.248 12.2152 24.005 11.7022 24.005C11.3332 24.005 11.1262 24.185 11.1262 24.419V24.428C11.1262 24.707 11.3242 24.851 12.1252 25.148C13.3222 25.535 14.0692 26.021 14.0692 27.092V27.11C14.0692 28.334 13.1242 29.09 11.7742 29.09ZM17.7631 29.117C16.0621 29.117 14.8471 27.812 14.8471 25.922V25.787C14.8471 23.906 16.0801 22.583 17.7721 22.583C19.4731 22.583 20.6881 23.888 20.6881 25.778V25.913C20.6881 27.794 19.4551 29.117 17.7631 29.117ZM17.7721 27.65C18.5281 27.65 19.0321 26.993 19.0321 25.904V25.805C19.0321 24.716 18.5101 24.05 17.7631 24.05C17.0161 24.05 16.5031 24.707 16.5031 25.796V25.895C16.5031 26.984 17.0251 27.65 17.7721 27.65ZM24.3951 29.108C22.7841 29.108 21.5331 27.875 21.5331 25.913V25.805C21.5331 23.861 22.8021 22.592 24.4581 22.592C25.4481 22.592 26.1231 22.979 26.6361 23.582L25.5921 24.689C25.3221 24.365 24.9801 24.095 24.4851 24.095C23.7471 24.095 23.1981 24.752 23.1981 25.823V25.859C23.1981 26.984 23.7561 27.605 24.4851 27.605C25.0251 27.605 25.3491 27.317 25.6371 26.984L26.6631 28.028C26.1501 28.658 25.4481 29.108 24.3951 29.108Z"
      fill="#0099C7"
    />
  </svg>
);
